<template>
    <div class="echarts-container" :id="id" />
</template>

<script>
import { debounce } from '@/utils'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'
export default {
    name: 'EchartsPie',
    props: {
        pieData: {
            type: Array,
            default: () => []
        },
        id: {
            type: String,
            default: 'pie'
        }
    },
    watch: {
        pieData(val) {
            if (!val) return
            this.initChart()
        },
        getCollapse() {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if (this.echartsDom) this.echartsDom.resize()
            }, 350)
        }
    },
    computed: {
        ...mapGetters('common', {
            getCollapse: 'getCollapse'
        })
    },
    mounted() {
        if (!this.pieData) return
        this.initChart()
        this.__resizeHandler = debounce(() => {
            if (this.echartsDom) this.echartsDom.resize()
        }, 350)
        window.addEventListener('resize', this.__resizeHandler)
    },
    data() {
        return {
            echartsDom: null,
            timer: null,
            selectedBlock: [],
            selectedName: []
        }
    },
    beforeDestroy() {
        if (!this.echartsDom) {
            return
        }
        clearTimeout(this.timer)
        window.removeEventListener('resize', this.__resizeHandler)
        this.echartsDom.dispose()
        this.echartsDom = null
    },
    methods: {
        initChart() {
            this.echartsDom = echarts.getInstanceByDom(document.getElementById(this.id))
            if (this.echartsDom == null) {
                this.echartsDom = echarts.init(document.getElementById(this.id), null, { renderer: 'svg' })
            }
            let option = {
                color: ['#989898','#fd349c','#00b8f5','#1e49e2','#00338d','#269924'],

                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'item',
                    confine: true
                },
                legend: {
                    orient: 'horizontal',
                    x: 'left',
                    y: 'bottom',
                    icon: 'circle',
                    itemWidth: 8,
                    textStyle: {
                        color: '#333333',
                        fontSize: this.$i18n.locale === 'zh' ? 11 : 10,
                        lineHeight: this.$i18n.locale === 'zh' ? 11 : 10
                    }
                },
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '42%'],
                        radius: [0, '45%'],
                        label: {
                            color: '#16313e',
                            width: 100,
                            fontFamily: 'KPMG',
                            fontWeight: 'bold',
                            fontSize: 12,
                            formatter: '{c} ({d}%)'
                        },
                        itemStyle: {
                            borderWidth: 0,
                            borderColor: '#fff'
                        },
                        data: this.pieData.map((v) => ({ selected: false, ...v })),
                        emphasis: {
                            itemStyle: {
                                borderWidth: 0,
                                shadowBlur: 0,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                                // borderColor: '#000',
                                // borderWidth: 2
                            }
                        },
                        selectedMode: 'single',
                        select: {
                            itemStyle: {
                                borderColor: '#000',
                                borderWidth: 2
                            }
                        }
                    }
                ]
            }
            this.echartsDom.setOption(option, true)
            this.echartsDom.off('click') // 清除事件
            this.echartsDom.on('click', (e) => {
                const options = this.echartsDom.getOption()
                 

                if (this.id == 'confirmation-pie') {
                    window.__confirmationCleanSelec_bar1 && window.__confirmationCleanSelec_bar1()
                    window.__confirmationCleanSelec_bar2 && window.__confirmationCleanSelec_bar2()
                    window.__confirmationCleanSelec_bar3 && window.__confirmationCleanSelec_bar3()
                    window.__confirmationCleanSelec_xbar && window.__confirmationCleanSelec_xbar()

                    const selectedMap = options.series[0].selectedMap
                    let status = []
                    // 制作中函证
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._1')] &&
                        selectedMap[this.$t('confirmation_status._1')] === true
                    ) {
                        status = ['1']
                    }
                    // 待被审计单位签字盖章
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._2')] &&
                        selectedMap[this.$t('confirmation_status._2')] === true
                    ) {
                        status = ['2']
                    }
                    // 已签字盖章并寄往毕马威
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._3_3')] &&
                        selectedMap[this.$t('confirmation_status._3_3')] === true
                    ) {
                        status = ['3']
                    }
                    // 已发往被函证方
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._4')] &&
                        selectedMap[this.$t('confirmation_status._4')] === true
                    ) {
                        status = ['4']
                    }
                    // 被函证方已接收但尚未回函
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._5')] &&
                        selectedMap[this.$t('confirmation_status._5')] === true
                    ) {
                        status = ['5']
                    }
                    // 已收到回函
                    if (
                        selectedMap &&
                        selectedMap[this.$t('confirmation_status._6')] &&
                        selectedMap[this.$t('confirmation_status._6')] === true
                    ) {
                        status = ['6']
                    }
                    if (status.length > 0) {
                        window.__listenDashboardChangeFilter && window.__listenDashboardChangeFilter({ status })
                        this.$message.success(this.$t('confirmation_dashboard_filtered'))
                    }
                }
            })
            if (this.id == 'confirmation-pie') {
                window.__confirmationCleanSelec_pie = (e) => {
                    //  
                    const options = this.echartsDom.getOption()
                    //  

                    options.series.forEach((v, k) => {
                        v.selectedMap
                            ? Object.keys(v.selectedMap).forEach((kk) => {
                                  if (v.selectedMap[kk]) {
                                      v.selectedMap[kk] = false
                                  }
                              })
                            : ''
                    })

                    //  
                    this.echartsDom.setOption(options, true)
                }
            }
        }
    }
}
</script>

<style scoped>
.echarts-container {
    width: 100%;
    height: 100%;
}
</style>
